<button mat-button color="primary" style="text-align: right; cursor: pointer; float:right;" (click)="dismiss()">Close</button>
@for (error of errors; track error) {
  <span class="example-pizza-party">
    {{ error }}<br>
  </span>
}
